import { useLayoutEffect, useState } from 'react';
import { MOBILE_BANNER_KEY } from '../utils/constants';
import { BREAKPOINTS } from 'utils/style/constants.style';

const useMobileBanner = () => {
  const [isBannerDismissed, setIsBannerDismissed] = useState<boolean>(
    !!sessionStorage.getItem(MOBILE_BANNER_KEY)
  );
  const [isScreenSmall, setIsScreenSmall] = useState<boolean>(false);

  useLayoutEffect(() => {
    setIsScreenSmall(window.innerWidth <= BREAKPOINTS.xs);
  }, []);

  const dismissBanner = () => {
    setIsBannerDismissed(true);
    sessionStorage.setItem(MOBILE_BANNER_KEY, 'true');
  };

  return { showBanner: !isBannerDismissed && isScreenSmall, dismissBanner };
};

export default useMobileBanner;
